import { BatchingConfig } from './batching-config';
import { DocumentConfig } from './document-config';
import { FlowConvoyPattern } from './flow-convoy-pattern';
import { Partner } from '../../partner/models/partner';
import { User } from '../../user/models/user';
import { TransportOutConfiguration } from '../../transport/models/transport-configuration';
import { DistributionTemplateDirection } from './distribution-template-direction';
import { PresentationDuplicateCheckConfiguration } from './presentation-duplicate-check-configuration';
import { AcknowledgementOption } from './acknowledgementOption';
import { AlertConfiguration } from '../../alerts/models/alert-configuration';
import { ContextPropertyFilterDto } from './context-property-filter-dto';

export class Distribution {

    constructor() {
        // Set default backup-values
        this.UseCaching = false;
        this.UseCdmBackup = true;
        this.UseInterchangeOutBackup = true;
        this.UseMessageInBackup = true;

        // Because the default dropdown-value listen for null and not undefined: null all the values here:
        this.TransportConfigurationOut = null;
        this.FilenamingTypeId = null;
        this.DocumentConfigIn = null;
        this.DocumentConfigOut = null;
        this.BatchingConfigOut = null;
        this.EnabledDuplicateChecks = [];

        this.SendAcknowledgement = AcknowledgementOption.never;
    }

    DistributionsId: number;
    DistributionParameter: string;
    FlowConvoyPattern?: FlowConvoyPattern;
    FilenamingTypeId: number | null;
    BatchingFilenamingTypeId: number | null;
    IsActive: boolean;
    TransportConfigurationOut: TransportOutConfiguration | null;
    DocumentConfigIn: DocumentConfig | null;
    DocumentConfigOut: DocumentConfig | null;
    UseCdmBackup: boolean;
    UseInterchangeOutBackup: boolean;
    UseCaching: boolean;
    UseMessageInBackup: boolean;
    Description: string;
    PartnerIn: Partner;
    PartnerOut: Partner;
    SendAcknowledgement: AcknowledgementOption;
    ExpectAcknowledgement: boolean;
    AcknowledgementTimeout: number;
    DuplicateInterchangeCheck: boolean;
    EnabledDuplicateChecks: PresentationDuplicateCheckConfiguration[];
    BatchingConfigOut: BatchingConfig | null;
    DoBatching: boolean;
    IsDeleted: boolean;
    CreatedDate?: User;
    CreatedBy?: User;
    /**
     * @deprecated Avoid using `IsTemplate`. Template-related behavior should be derived from partner fields. DistributionService has methods to help with this.
     */
    IsTemplate: boolean; // deprecated
    /**
     * @deprecated Avoid using `TemplateDirection`. Template-related behavior should be derived from partner fields. DistributionService has methods to help with this.
     */
    TemplateDirection: DistributionTemplateDirection; // deprecated
    DaysToKeepDoubletCheckRecords: number;
    DocumentConfigOutBatchersId: number | null;
    BatchingConfigurationsId: number | null;
    AlertConfigurationPresentation: AlertConfiguration | null;
    ContextPropertyFilters: ContextPropertyFilterDto[];
}
